import type { ChatMessage } from '../types/chat-message.js';

function at(daysAgo: number, hours: number, minutes: number): string {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
}

/** Sample conversation for Storybook / playground */
export const DEMO_CHAT_MESSAGES: ChatMessage[] = [
  {
    id: '1',
    role: 'user',
    text: 'Скільки коштує відбілювання?',
    createdAt: at(1, 10, 15),
    status: 'read',
  },
  {
    id: '2',
    role: 'bot',
    text: 'Відбілювання від 3500 грн. Можу записати на консультацію.',
    createdAt: at(1, 10, 16),
  },
  {
    id: '3',
    role: 'user',
    text: 'А скільки триває процедура?',
    createdAt: at(0, 9, 42),
    status: 'delivered',
  },
  {
    id: '4',
    role: 'bot',
    text: 'Зазвичай 60–90 хвилин, залежно від складності.',
    createdAt: at(0, 9, 43),
  },
];

/** Messages spanning multiple days */
export const DEMO_MESSAGES_WITH_DATES: ChatMessage[] = [
  {
    id: 'd1',
    role: 'user',
    text: 'Добрий день! Цікавить імплантація.',
    createdAt: at(2, 14, 20),
    status: 'read',
  },
  {
    id: 'd2',
    role: 'bot',
    text: 'Вітаємо! Розкажіть, будь ласка, що саме вас цікавить.',
    createdAt: at(2, 14, 21),
  },
  {
    id: 'd3',
    role: 'user',
    text: 'Один зуб, нижня щелепа.',
    createdAt: at(1, 11, 5),
    status: 'read',
  },
  {
    id: 'd4',
    role: 'bot',
    text: 'Дякую! Можу запропонувати безкоштовну консультацію.',
    createdAt: at(1, 11, 7),
  },
  {
    id: 'd5',
    role: 'user',
    text: 'Так, запишіть мене, будь ласка.',
    createdAt: at(0, 16, 30),
    status: 'sent',
  },
];

/** Messages with emoji for Storybook / playground */
export const DEMO_EMOJI_MESSAGES: ChatMessage[] = [
  {
    id: 'e1',
    role: 'user',
    text: 'Дякую! 😊',
    createdAt: at(0, 11, 10),
    status: 'read',
  },
  {
    id: 'e2',
    role: 'bot',
    text: 'Завжди раді допомогти! 🙌 Записати вас на консультацію?',
    createdAt: at(0, 11, 11),
  },
  {
    id: 'e3',
    role: 'user',
    text: 'Так, будь ласка 👍',
    createdAt: at(0, 11, 12),
    status: 'delivered',
  },
];

/** Outgoing messages in every delivery status */
export const DEMO_MESSAGE_STATUSES: ChatMessage[] = [
  {
    id: 's1',
    role: 'user',
    text: 'Надсилається…',
    createdAt: at(0, 12, 0),
    status: 'sending',
  },
  {
    id: 's2',
    role: 'user',
    text: 'Надіслано',
    createdAt: at(0, 12, 1),
    status: 'sent',
  },
  {
    id: 's3',
    role: 'user',
    text: 'Доставлено',
    createdAt: at(0, 12, 2),
    status: 'delivered',
  },
  {
    id: 's4',
    role: 'user',
    text: 'Прочитано',
    createdAt: at(0, 12, 3),
    status: 'read',
  },
  {
    id: 's5',
    role: 'user',
    text: 'Не вдалося надіслати',
    createdAt: at(0, 12, 4),
    status: 'failed',
    sendError: 'upload',
  },
];
